/**
 * 浏览器端错误链反查：按 digest 调用 /wiki-api/error-chain，
 * 把服务端记录的完整错误链以 Error 原样抛到浏览器控制台。
 *
 * React 生产构建会把 Server Components 错误的消息体替换为通用文案，但会保留 digest。
 * 错误边界组件挂载后调用本函数，控制台即可直接看到真实错误消息、堆栈与触发请求信息，
 * 免去人工到容器日志检索。
 */

export type ErrorChainRecord = {
  digest: string;
  message: string;
  stack: string | null;
  method: string;
  path: string;
  routePath: string;
  routeType: string;
  recordedAt: string;
};

/** 把反查到的完整错误链按 Error 原样抛到浏览器控制台。 */
export function reportErrorChainToConsole(error: Error & { digest?: string }): void {
  const digest = error.digest;
  if (!digest) return;

  fetch(`/wiki-api/error-chain?digest=${encodeURIComponent(digest)}`)
    .then(async (response) => {
      if (!response.ok) throw new Error(`error-chain API ${response.status}`);
      const payload = (await response.json()) as { found: boolean; record?: ErrorChainRecord };
      if (!payload.found || !payload.record) return;

      const record = payload.record;
      console.error(
        `[error-chain] ${record.method} ${record.path} ` +
          `(route=${record.routePath} type=${record.routeType} digest=${record.digest} ` +
          `at=${record.recordedAt}):`,
        Object.assign(new Error(record.message), {
          stack: record.stack ?? undefined,
        }),
      );
    })
    .catch((fetchError: unknown) => {
      console.error('[error-chain] 完整错误链反查失败：', fetchError);
    });
}
